const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MPPaymentOnDeliveryCommissionQuery: any = {
    GetCodCommissionRanges: Backofficebff + '/v1/CodCommissionRange/get-cod-commission-range',
};
